import { h } from 'preact';
import Weather from './components/weather';
import definition from './intl.json';
import intl from 'preact-i18n';

function intlWrap(component) { return intl(component, { scope: 'weather-widget', definition }); }

export const WeatherWidget = intlWrap(Weather);
export default WeatherWidget;
export const WeatherCompact = intlWrap(props => <Weather {...props} displaMode="compact" />);
export const WeatherMini = intlWrap(props => <Weather {...props} displaMode="mini" />);
